<template>
	<div class="row contentblock">
		<div class="columns column6">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 col-content">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	padding: 0;
	justify-content: space-between;
	margin: 10px auto;

	&:nth-child(odd) {
		flex-direction: row-reverse;
	}

	.columns {
		width: calc(50% - 5px);

		&:first-child {
			padding: 0;
		}
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		background: var(--light-background-color);
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		align-items: center;
	}

	.contentblock-content {
		padding: 20px 50px;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.columns {
			width: 100%;
			margin: 0 0 20px;
		}

		.contentblock-content {
			padding: 40px 20px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		.contentblock-content {
			padding: 30px 20px;
		}
	}
}
</style>
